import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-4" data-aos="fade-up" data-aos-delay="200">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="HelpCircle" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
            Pertanyaan Umum
          </h3>
          <p className="text-sm text-muted-foreground">
            Jawaban untuk pertanyaan yang sering diajukan
          </p>
        </div>
      </div>
      <div className="space-y-3">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-lg overflow-hidden hover:border-primary transition-colors duration-300"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full p-4 flex items-center justify-between text-left hover:bg-muted transition-colors"
            >
              <span className="font-heading font-semibold text-sm md:text-base text-foreground pr-4">
                {faq?.question}
              </span>
              <Icon
                name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                size={20}
                color="var(--color-primary)"
                className="flex-shrink-0"
              />
            </button>
            {openIndex === index && (
              <div className="px-4 pb-4">
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;